export { default as bouncingBallData } from './bounching_ball_data.json';
export { default as stickAndBallData } from './stick_and_ball_data.json';
export { default as correctData } from './correct_data.json';
export { default as incorrectData } from './incorrect_data.json';
export { default as confettiData } from './confetti_data.json';
export { default as confettiBackgroundData } from './confetti_background_data.json';
